export default "__VITE_ASSET__DwC2LGq3__"